import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.00033 5.5C2.98774 5.5 2.1669 6.32091 2.16699 7.33353L2.16755 13.3335C2.16764 14.3459 2.98843 15.1667 4.00088 15.1667H12.0002C13.0127 15.1667 13.8335 14.3459 13.8335 13.3333V7.33333C13.8335 6.32081 13.0127 5.5 12.0002 5.5H4.00033ZM8.66699 9.66666C8.66699 9.29846 8.36853 9 8.00033 9C7.63213 9 7.33366 9.29846 7.33366 9.66666V11C7.33366 11.3682 7.63213 11.6667 8.00033 11.6667C8.36853 11.6667 8.66699 11.3682 8.66699 11V9.66666Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.33366 4.33333C4.33366 2.30828 5.97528 0.666664 8.00033 0.666664C9.64106 0.666664 10.8081 1.7321 11.2955 3.11116C11.4183 3.45831 11.2363 3.83919 10.8891 3.96189C10.542 4.08459 10.1611 3.90264 10.0385 3.5555C9.70219 2.60418 8.97206 2 8.00033 2C6.71166 2 5.66699 3.04466 5.66699 4.33333V6C5.66699 6.36818 5.36851 6.66666 5.00033 6.66666C4.63214 6.66666 4.33366 6.36818 4.33366 6V4.33333Z",
		fill: "currentColor"
	})]
});
export default SvgUnlock;
